import { render, staticRenderFns } from "./setting-config-tab.vue?vue&type=template&id=3e925abc&scoped=true"
import script from "./setting-config-tab.vue?vue&type=script&lang=js"
export * from "./setting-config-tab.vue?vue&type=script&lang=js"
import style0 from "./setting-config-tab.vue?vue&type=style&index=0&id=3e925abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e925abc",
  null
  
)

export default component.exports